import React from 'react';
import Calculator from './Calculator';

const CalculatorRoute = () => (
  <div className="calculator-page">
    <h2>Let&apos;s do some math!</h2>
    <Calculator />
  </div>
);

export default CalculatorRoute;
